import { LuGlobe } from '@react-icons/all-files/lu/LuGlobe'
import React from 'react'

import { Flex } from 'components/ds'
import { ColumnHeaderFilterIcon } from 'components/search/search-columns/column-header-filter-icon'
import { SourceFilterMenu } from 'components/search/search-columns/source-column/source-filter-menu'

export const SourceColumnFilter = () => (
  <Flex align="center" gap="2">
    Source
    <Flex onClick={e => e.stopPropagation()}>
      <SourceFilterMenu
        renderTrigger={({ isFiltered }) => (
          <ColumnHeaderFilterIcon
            isFiltered={isFiltered}
            icon={<LuGlobe />}
            aria-label="Filter source results"
          />
        )}
      />
    </Flex>
  </Flex>
)
